import { AgentDebtRiskType } from '@g2-shared/api-client/generated/risk-app';

export const AgentDebtRiskTypeOptions: Record<AgentDebtRiskType, string> = {
  [AgentDebtRiskType.MULTI_SERVICE_MULTI_CURRENCY]: 'Multi service - multi currency',
  [AgentDebtRiskType.MULTI_SERVICE_SINGLE_CURRENCY]: 'Multi service - single currency',
  [AgentDebtRiskType.SINGLE_SERVICE_MULTI_CURRENCY]: 'Single service - multi currency',
  [AgentDebtRiskType.SINGLE_SERVICE_SINGLE_CURRENCY]: 'Single service - single currency',
};
